import { render, staticRenderFns } from "./ReceiverListOfReadComp.vue?vue&type=template&id=2a02591c&scoped=true"
import script from "./ReceiverListOfReadComp.vue?vue&type=script&lang=ts"
export * from "./ReceiverListOfReadComp.vue?vue&type=script&lang=ts"
import style0 from "./ReceiverListOfReadComp.vue?vue&type=style&index=0&id=2a02591c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a02591c",
  null
  
)

export default component.exports